export const EVENT = 'Event';
export const RENDERER = 'Renderer State';
export const ERROR = 'Error';
export const COMMAND = 'Command';
export const CONFIG = 'Config';
export const MEDIA = 'Media';
